<template>
  <Layout>
    <Title :height="28" imgUrl="url('@/assets/img/bg-serv-white-title.svg')">
      <img src="@/assets/img/mentoria-title-logo.svg" class="h-44 w-auto" alt="Mentoria Service logo" />
    </Title>
    <About
      title="A chave para o seu sucesso profissional"
      text="Seja um recém-formado ou um profissional experiente, a Mentoria Service está aqui para impulsionar seu crescimento. Receba orientações individualizadas para levar sua carreira ao próximo patamar."
      service="mentoria"
      video-url="https://advservice-images.s3.amazonaws.com/videos/mentoria+service+.mp4"
      thumbnail-url="https://advservice-images.s3.amazonaws.com/solutions/mentoria%20service.png"
    />
    <Benefits :solutionId="7" />
    <PlansComparison :solution-id="7" />
    <Solutions title="Mais soluções" />
    <Depoimentos title="Depoimentos" />
    <Faq title="Perguntas Frequentes" :questions="faqStore.questions" />
  </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';
import About from '@/components/About/About.vue';

const faqStore = useFaqStore();
</script>
